<svelte:options runes={false} />

<script lang="ts">
	import { format } from 'svelte-i18n';

	import { Button, Loader, Text } from '@Shelly/shelly-design-system';

	export let error: unknown = null;
	export let onRetry: (() => void) | null = null;
</script>

<div
	class="route-loading d-flex flex-column align-items-center justify-content-center p-l"
	role={error ? 'alert' : 'status'}
	aria-live="polite"
>
	{#if error}
		<Text class="mb-m" styleType="body">
			{$format('alert_route_load_error', { default: 'Unable to load this page.' })}
		</Text>
		{#if onRetry}
			<Button
				type="button"
				size="m"
				aria-label={$format('button_retry', { default: 'Retry' })}
				on:click={onRetry}
			>
				{$format('button_retry', { default: 'Retry' })}
			</Button>
		{/if}
	{:else}
		<Loader size="l" />
		<Text class="mt-m" styleType="body">
			{$format('loading_title_loading', { default: 'Loading ...' })}
		</Text>
	{/if}
</div>

<style>
	.route-loading {
		min-height: 100vh;
		text-align: center;
	}
</style>
